import { render, staticRenderFns } from "./AvailableProjects.vue?vue&type=template&id=6bcc5f90&scoped=true&"
import script from "./AvailableProjects.vue?vue&type=script&lang=js&"
export * from "./AvailableProjects.vue?vue&type=script&lang=js&"
import style0 from "./AvailableProjects.vue?vue&type=style&index=0&id=6bcc5f90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcc5f90",
  null
  
)

export default component.exports